import type { Inverters } from '~/types/equipment';

import installationRiskHttp from '~/services/installation-risk-api/installation-risk-api.http';

class InvertersService {
  private readonly endpoint = '/v1/inverters';

  private static buildQueryString(params: any): string {
    const searchParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value.toString());
      }
    });

    return searchParams.toString();
  }

  async create(data: Inverters.CreateInverterRequest): Promise<Inverters.Inverter> {
    const response = await installationRiskHttp.post(this.endpoint, data);
    return response.data;
  }

  async getById(id: number): Promise<Inverters.Inverter> {
    const response = await installationRiskHttp.get(`${this.endpoint}/${id}`);
    return response.data;
  }

  async list(params: Inverters.GetInvertersRequest): Promise<Inverters.GetInvertersResponse> {
    const queryString = InvertersService.buildQueryString(params);
    const url = queryString ? `${this.endpoint}?${queryString}` : this.endpoint;
    const response = await installationRiskHttp.get(url);
    return response.data;
  }

  async update(id: number, data: Inverters.UpdateInverterRequest): Promise<Inverters.Inverter> {
    const response = await installationRiskHttp.put(`${this.endpoint}/${id}`, data);
    return response.data;
  }
}

const invertersService = new InvertersService();

export default invertersService;
